<div class="fc-confirm-dialog">
    <div class="fc-confirm-dialog-title">
        <h4>{{ 'DOWNLOAD_LIMIT_REACHED.TITLE' | translate }}</h4>
    </div>

    <div class="fc-confirm-dialog-body">
        <p>{{ 'DOWNLOAD_LIMIT_REACHED.BODY' | translate }}</p>
    </div>

    <div class="fc-confirm-dialog-action-buttons">
        <button fcp-button (click)="close()">
            {{ 'TEXT_CLOSE' | translate }}
        </button>
    </div>
</div>
